import DataService from '@/services/data-service'
import MetaService from '@/services/meta-service'

// Default Api page (Use if don't need extended functionality)
export default {
  apiPath: DataService.apiPath,
  methods: {
    setData(payload) {
      this.payload = payload
      MetaService.updateMeta(payload)
    }
  },
  beforeRouteEnter(to, from, next) {
    DataService
      .getData(to.meta.postData)
      .then((payload) => {
        next(vm => {
          vm.setData(payload)
        })
      })
  }
}
